export default __webpack_public_path__ + "static/media/back-arrow.268c19d8.svg";